import i18n from "i18next";
import languageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import { loggerFactory } from "src/logging";
import { isUnitTesting } from "src/utils";
import { DEFAULT_LANGUAGE, Languages } from "./constants";
import cs from "./cs.json";
import en from "./en.json";
import { currencyFormatter, localDateFormatter, ordinalFormatter, percentFormatter, regionFormatter } from "./formatters";
import pl from "./pl.json";

const resources = {
    en: { translation: en },
    cs: { translation: cs },
    pl: { translation: pl },
};

export const initTranslations = () => {
    i18n.use(initReactI18next) // passes i18n down to react-
        .use(languageDetector)
        .init({
            resources,
            fallbackLng: DEFAULT_LANGUAGE,
            detection: {
                convertDetectedLanguage: (lng: string) => {
                    switch (lng) {
                        case "cs-CZ":
                        case "cs":
                            return Languages.cs;
                        default:
                            return Languages.en;
                    }
                },
            },
            interpolation: {
                escapeValue: false, // react already safes from xss
            },
            parseMissingKeyHandler: (key, defaultValue) => {
                if (isUnitTesting) {
                    return key;
                }

                loggerFactory.getLogger("core/translations").warn("Missing key: %s", key);
                return defaultValue || `(${key})`;
            },
        });

    i18n.services.formatter?.add("region", regionFormatter);
    i18n.services.formatter?.add("localDate", localDateFormatter);
    i18n.services.formatter?.add("ordinal", ordinalFormatter);
    i18n.services.formatter?.add("currency", currencyFormatter);
    i18n.services.formatter?.add("percent", percentFormatter);
};

export const setLanguage = (language: Languages) => {
    i18n.changeLanguage(language);
};
